import { ETopBetsStatus, ITopBetsState } from '../../types/reducers/topBets';

export function initDefaultState(): ITopBetsState {
  return {
    status: ETopBetsStatus.initial,
    errorCode: null,
    requestDateTime: new Date().toISOString(),
    leaders: [],
    serpUrl: null,
  };
}
